module.exports = __webpack_public_path__ + "assets/img/mecha-btn-8cd197d7.png";